import src from "IMAGE";
export default { src, width: 575, height: 670, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
